<p-dialog header="" [modal]="true" [(visible)]="FreeTrialFeatureDialogVisible"
    [style]="{'width': '480px'}" (onHide)="closeDialog()"  >
    <div class="dialog-content bg-white">
        <div class="text-center">
            <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" [alt]="'freeTrialFeatureDialog.logo' | transloco"  />
        </div>

        <p class="text-center mb-2 ">
            {{ 'freeTrialFeatureDialog.experienceFullPotential' | transloco }}
        </p>

        <ul class="list-group list-group-flush dialog-list">
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.unlimitedArtworks' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.unlimitedConnectedGalleries' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.multipleArtworkTypes' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.aiAssistedDescriptionWriting' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.linksToInstagramAndFacebook' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.advancedInsightsAndReporting' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.accessToGalleryInstantMessenger' | transloco }}
            </li>
            <li class="list-group-item d-flex align-items-center">
                <i class="fa fa-check-circle text-primary me-2 fs-4"></i> {{ 'freeTrialFeatureDialog.allowGalleriesToView' | transloco }}
            </li>
        </ul>
    </div>

</p-dialog>
